export default __webpack_public_path__ + "static/media/meycauayan.0e7904ee.jpg";